$(document).ready(function () {
	let $tabProduct = $('#tabs-product');

	if ($tabProduct.length) {
		let $navLink = $tabProduct.find('.nav-link').first();
		$navLink.addClass('active');

		let $tabPane = $tabProduct.closest('body').find('.tab-pane').first();
		$tabPane.addClass('active show');
	}
});
